<script>
export default {
///
//本番用
///

    /**
     * 再生ファイル（base64）取得 API URL
     * パスの末尾にSendNoをつけて使用すること
     */
    getSendHist : 'https://gmino.s-alert.net/api/ReplyWeb/WebLinkage/GetWebSendHist/',

    /**
     * 再生ファイル（base64）取得 API URL
     * パスの末尾にSendNoをつけて使用すること
     */
    playMp3: 'https://gmino.s-alert.net/api/SendHists/Web/SoundFile/',

    /**
     * 画像表示に必要なsasトークンを取得するAPI URL
     * 取得したsasトークンは、ファイルパスの末尾につなげる
     */
     getSasToken : 'https://gmino.s-alert.net/api/Storage/SasToken',

}
</script>